import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=56b5dcb8&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=56b5dcb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5dcb8",
  null
  
)

export default component.exports